"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var BuyOverlay = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(BuyOverlay, _window$AbstractEleme);

    var _super = _createSuper(BuyOverlay);

    function BuyOverlay(id, options) {
      var _this;

      _classCallCheck(this, BuyOverlay);

      var OPTIONS_MANDATORY = {
        watchResize: true,
        watchResizeTimeout: 300
      };
      options = $.extend(true, _.clone(options), OPTIONS_MANDATORY);
      _this = _super.call(this, id, options);
      _this.$refElement = options.$refElement;
      _this.$menu = _this.$domElement.find(".buy-overlay-menu");
      _this.$sizesBtn = _this.$menu.find(".buy-overlay-menu__sizes-btn");
      _this.$buyBtn = _this.$menu.find(".buy-overlay-menu__buy-btn");
      _this.$closeBtn = _this.$domElement.find(".buy-overlay-list .buy-overlay-list__header .btn-close");
      _this.$listContent = _this.$domElement.find(".buy-overlay-list .buy-overlay-list__content .list-group");
      _this.$variantBtns = _this.$listContent.find(".list-group-item-action");
      _this.$backdrop = _this.$domElement.find(".buy-overlay-backdrop");
      _this.AJAXrequest = null;
      _this.refElementObserver = null;
      _this.selectedVariantID = null;
      return _this;
    }

    _createClass(BuyOverlay, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$sizesBtn.on("click", function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this2.$domElement.toggleClass("expanded");

          if (Detectizr.device.type == "desktop") {
            $("body").css("overflow", "hidden");
          }

          if (_this2.$domElement.hasClass("expanded")) {
            $("html").attr("last-scroll-position", $(window).scrollTop());

            _this2.$buyBtn.prop("disabled", true);

            window.TweenMax.set(_this2.$listContent, {
              scrollTo: {
                y: 0,
                autoKill: false
              }
            });
          } else {
            _this2.$buyBtn.prop("disabled", false);

            Globals.bodyScrollEnabled = true;

            if ($("html").attr("last-scroll-position") !== undefined) {
              window.TweenMax.set(window, {
                scrollTo: {
                  y: $("html").attr("last-scroll-position")
                }
              });
              $("html").removeAttr("last-scroll-position");
            }
          }
        });
        this.$buyBtn.on("click", function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (!Globals.checkCookieBeforeUsingCart()) {
            return;
          }

          var $firstSizeBtn = _this2.$listContent.find(".list-group-item.list-group-item-action:first-of-type");

          if ($firstSizeBtn.attr("data-variant-value").toLowerCase() == "one size" || $firstSizeBtn.attr("data-gift-card").toLowerCase() == "true") {
            $firstSizeBtn.trigger("click");
          }

          _this2.selectedVariantID ? _this2.addToCart() : _this2.$sizesBtn.trigger("click");
        });
        this.$closeBtn.on("click", function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();
          Globals.bodyScrollEnabled = true;

          if ($("html").attr("last-scroll-position") !== undefined) {
            window.TweenMax.set(window, {
              scrollTo: {
                y: $("html").attr("last-scroll-position")
              }
            });
            $("html").removeAttr("last-scroll-position");
          }

          _this2.$domElement.removeClass("expanded");

          _this2.$buyBtn.prop("disabled", false);
        });
        this.$backdrop.on("click", function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this2.$closeBtn.trigger("click");
        });
        this.$variantBtns.on("click", function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();
          _this2.selectedVariantID = $(event.delegateTarget).attr("data-variant-id");

          if (Globals.isVariantInCart(_this2.selectedVariantID)) {
            $(window).trigger(window.HelperModal.CLASSNAME + ".show", [{
              theme: window.AbstractBootstrapModal.THEME_WARNING,
              closeBtn: true,
              header: window.theme.strings.helper_modal.try_to_add_duplicated_product_in_cart.header_html,
              body: window.theme.strings.helper_modal.try_to_add_duplicated_product_in_cart.body_html
            }]);
            return;
          }

          _this2.$variantBtns.removeClass("active");

          $(event.delegateTarget).addClass("active");

          _this2.$sizesBtn.find("span").attr("data-selected-size", "(" + $(event.delegateTarget).find(".size-default").html().replace(/<(?:.|\n)*?>/gm, " ").replace(/\s{2,}/g, " ") + ")");

          _this2.$buyBtn.removeClass("btn-primary").addClass("btn-success");

          _this2.$closeBtn.trigger("click");
        });
        this.watchPage();
        this.$refElement.on(window.ScrollWatcher.IS_IN_VIEWPORT, function (event, data) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this2.show();
        });
        this.$refElement.on(window.ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT, function (event, data) {
          event.stopPropagation();
          event.stopImmediatePropagation();

          _this2.hide();
        });

        this._sortSizeButtons();

        _get(_getPrototypeOf(BuyOverlay.prototype), "init", this).call(this);
      }
    }, {
      key: "watchPage",
      value: function watchPage() {
        if (this.refElementObserver) {
          this.refElementObserver.dispose();
          this.refElementObserver = null;
        }

        this.refElementObserver = new window.ScrollWatcher();
        this.refElementObserver.init(this.$refElement, {
          rootMargin: this.elementObserverRootMargin,
          threshold: null,
          thresholdStep: null
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.$variantBtns.removeClass("active");
        this.$sizesBtn.find("span").attr("data-selected-size", "");
        this.$buyBtn.removeClass("btn-success").addClass("btn-primary");
        this.selectedVariantID = null;
      }
    }, {
      key: "addToCart",
      value: function addToCart() {
        var _this3 = this;

        this._killAJAXRequest();

        console.log("\n\n\n addToCart \n\n", this.selectedVariantID);

        if (Globals.isVariantInCart(this.selectedVariantID)) {
          $(window).trigger(window.HelperModal.CLASSNAME + ".show", [{
            theme: window.AbstractBootstrapModal.THEME_WARNING,
            closeBtn: true,
            header: window.theme.strings.helper_modal.try_to_add_duplicated_product_in_cart.header_html,
            body: window.theme.strings.helper_modal.try_to_add_duplicated_product_in_cart.body_html
          }]);
          this.reset();
          return;
        }

        this.AJAXrequest = $.ajax({
          method: "POST",
          dataType: "json",
          data: {
            quantity: 1,
            id: this.selectedVariantID
          },
          url: window.Globals.CART_ADD_URL,
          success: function success(response) {
            _this3.reset();

            _this3.$domElement.trigger(CartPage.CART_CHANGE_SUCCESS, [response]);

            $(window).trigger("quickcart.open");
          },
          error: function error(err) {
            _this3.$domElement.trigger(CartPage.CART_CHANGE_ERROR, [err]);

            _this3.reset();
          }
        });
        /*
        GA4
        */

        var details = {
          id: this.$domElement.find(".buy-overlay-list__content").attr("data-id"),
          title: this.$domElement.find(".buy-overlay-list__content").attr('data-title'),
          vendor: this.$domElement.find(".buy-overlay-list__content").attr('data-vendor'),
          tags: this.$domElement.find(".buy-overlay-list__content").attr("data-tags").split(";"),
          variants: [{
            option2: this.$domElement.find(".buy-overlay-list__content").attr("data-gender") !== '' ? this.$domElement.find(".buy-overlay-list__content").attr("data-gender") : undefined
          }],
          price: this.$domElement.find(".buy-overlay-list__content").attr('data-price')
        };
        this.pushAddToCartDataLayer(details, this.$domElement.find(".buy-overlay-list__content").attr("data-total"), this.$domElement.find(".buy-overlay-list__content").attr('data-desktop'));
      }
      /*
      GA4
      */

    }, {
      key: "pushAddToCartDataLayer",
      value: function pushAddToCartDataLayer(product_info, inventory_q, is_desktop) {
        console.log('----> pushAddToCartDataLayer');
        console.log('----> is_desktop', is_desktop);
        var products = [];
        var item_category3 = '';
        var item_category4;
        var color = '';
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          if (tag.indexOf('type') > -1) {
            item_category3 = tag.split('-')[1];
          }

          if (tag.indexOf('long_color') > -1) {
            color = tag.split('-')[1];
          }
        });
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          //console.log('item_category3', item_category3);
          if (tag.indexOf('subcategory') > -1) {
            //console.log('tag.split', tag.split('-')[1]);
            if (tag.split('-')[1] != item_category3) {
              item_category4 = tag.split('-')[1];
            }
          }
        });
        product_info.tags.forEach(function (tag) {
          //console.log('tag', tag);
          //console.log('item_category3', item_category3);
          if (tag.indexOf('abb2') > -1) {
            //console.log('tag.split', tag.split('-')[1]);
            if (tag.split('-')[1] != item_category3) {
              var second = tag.split('-')[2] ? '-' + tag.split('-')[2] : '';
              item_category4 = tag.split('-')[1] + second;
            }
          }
        });
        var temp_price = '';

        if (is_desktop === true || is_desktop === 'true') {
          temp_price = product_info.price;
        } else {
          temp_price = slate.Currency.formatMoney(Number(product_info.price), Globals.moneyFormat).toString().replace('€', '').replace('.', '').replace(',', '.');
        }

        var temp_pr = {
          item_id: product_info.id.toString(),
          item_name: product_info.title,
          currency: Shopify.currency.active,
          index: undefined,
          item_brand: product_info.vendor,
          item_category: "Apparel",
          item_category2: product_info.variants[0].option2,
          item_category3: item_category3,
          item_category4: item_category4,
          item_variant: this.selectedVariantID.toString(),
          price: Number(temp_price),
          available_quantity: Number(inventory_q),
          quantity: 1
        };
        products.push(temp_pr);
        /* console.log('dataLayerPush', {
        event: "add_to_cart",
        ecommerce: {
          items: products
        }
        }); */

        dataLayer.push({
          ecommerce: null
        });
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            items: products
          }
        });
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "resizeTimeoutHandler",
      value: function resizeTimeoutHandler() {
        this.watchPage();
      }
    }, {
      key: "show",
      value: function show() {
        this.$domElement.removeClass("menu-hidden");
      }
    }, {
      key: "hide",
      value: function hide() {
        this.$closeBtn.trigger("click");
        this.$domElement.addClass("menu-hidden");
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.watchPage = function () {};

        this._killAJAXRequest();

        this.$domElement.find(".buy-overlay-list-row").off("transitionend oTransitionEnd webkitTransitionEnd");
        this.$refElement.off(window.ScrollWatcher.IS_IN_VIEWPORT);
        this.$refElement.off(window.ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT);
        $(window).off(Globals.ALL_VARIANTS_UPDATED + "." + this.id);
        this.$closeBtn.off("click");
        this.$sizesBtn.off("click");
        this.$buyBtn.off("click");
        this.$variantBtns.off("click");

        if (this.refElementObserver) {
          this.refElementObserver.dispose();
          this.refElementObserver = null;
        }

        this.$backdrop = null;
        this.$refElement = null;
        this.$sizesBtn = null;
        this.$buyBtn = null;
        this.$closeBtn = null;
        this.$listContent = null;
        this.$variantBtns = null;
        this.selectedVariantID = null;
        Globals.bodyScrollEnabled = true;

        _get(_getPrototypeOf(BuyOverlay.prototype), "dispose", this).call(this);
      }
    }, {
      key: "_killAJAXRequest",
      value: function _killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }, {
      key: "_sortSizeButtons",
      value: function _sortSizeButtons() {
        var SIZE_MAP = ["4xs", "3XS", "J2XS", "2XXS", "JXXS", "JXS", "JS", "JM", "JL", "JXL", "JXXL", "J2XL", "JXXXL", "J3XL", "JXS/S", "JXS-S", "JS/M", "JS-M", "JM/L", "JM-L", "JL/XL", "JL-XL", "JXL/XXL", "JXL-XXL", "JXXL/XXXL", "JXXL-XXXL", "JML", "JSM", "2XS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "XXXL", "3XL", "XS/S", "XS-S", "S/M", "S-M", "M/L", "M-L", "L/XL", "L-XL", "XL/XXL", "XL-XXL", "XXL/XXXL", "XXL-XXXL", "ML", "SM", "L-T", "53mm", "52mm", "54mm", "55mm", "m-t", "S-T", "XL2L"];
        var myVariants = new Array(SIZE_MAP.length);
        var $list = this.$domElement.find("button.list-group-item");
        /*
              console.log('beks1', $list[0]);
              console.log('beks2', $($list[0]));
              console.log('beks3', $($list[0]).data("gift-card"));*/

        if ($($list[0]).data("variant-value").toString().toLowerCase() == "one size" || $($list[0]).data("gift-card") == "true") {
          $($list[0]).css("order", 0);
        } else if ($($list[0]).data("variant-value").toString().match(SIZE_MAP.join("|"))) {
          $list.each(function (i, el) {
            var $value = $(el).data("variant-value");
            myVariants[_.indexOf(SIZE_MAP, $value)] = $value;
          });
          myVariants = _.compact(myVariants);
          $list.each(function (i, el) {
            var $el = $(el);
            $el.css("order", _.indexOf(myVariants, $el.data("variant-value")) + 1);
          });
        } else {
          var numericals = [];
          $list.each(function (i, el) {
            var $el = $(el);
            var val = $el.data("variant-value").toString();

            if (val.match(/\s(?=[1-9]\/)/)) {
              /*
                              7 1/4
                          */
              val = eval(val.replace(" ", "+"));
            } else {
              /*
                              3 anni
                              3s
                              13_5C
                              7Y
                              12-13.5
                          */
              val = parseFloat(val.replace(/(_|,)/g, ".").replace(/[^\d.]/g, ""));
            }

            if (isNaN(val)) {
              val = 0;
            }

            numericals.push({
              val: val,
              i: i
            });
          });
          numericals = numericals.sort(function (a, b) {
            return a.val - b.val;
          });

          for (var i = 0; i < numericals.length; i++) {
            $($list[numericals[i].i]).css("order", i);
          }
        }
      }
    }, {
      key: "elementObserverRootMargin",
      get: function get() {
        if (this.options.pageHasCover) {
          var NAVBAR_H = this.options.$navbarElement.outerHeight();
          var MENU_H = this.$menu.outerHeight();
          return -(window.ViewportUtils.height - (NAVBAR_H + MENU_H + 1)) + "px 0px -" + (NAVBAR_H + MENU_H) + "px 0px";
        } else {
          return -window.ViewportUtils.height + "px 0px 0px 0px";
        }
      }
    }]);

    return BuyOverlay;
  }(window.AbstractElement);

  window.BuyOverlay = BuyOverlay;
})(window);
